import React from "react";
import './IncludedServiceComponent.css';

import {
	MobileDeviceIconBlack
} from "../Svg/index";

const IncludedServiceComponent = (props) => {
	return (
		<React.Fragment>
			<div className="includedServiceComponentWrapper" style={{ backgroundColor: props.bgcolor, paddingBottom: props.isDevice ? "1.5rem" : "0" || '#ffffff'}}>
				{
					props.isDevice ?
						<div className="includedServiceComponentPlus"><MobileDeviceIconBlack /></div>
						:
						null
						// <div className="includedServiceComponentPlus" style={{ paddingTop: "0" }}>+</div>
				}
				<div className="includedServiceComponentText">
					{
						props?.inclusionsList?.map(item =>{
							return(
								<p className="includedServiceComponentName">+ {item}</p>
							)
						})
					}
				</div>
			</div>
		</React.Fragment>
	)
}

// <IncludedServiceComponent name="Samsung Galaxy S20 FE on Smart M + 20GB Data" subText="Cosmic black &nbsp; | &nbsp; 500MB" isDevice={false} bgcolor="#F4F4F4"></IncludedServiceComponent>

export default IncludedServiceComponent;